import axios from "axios";
import * as actions from "./actionTypes";
import messages from "../../messages";
import toastr from "toastr";
import PesoCompetenciaServices from "./pesoCompetencia.services";

export const getPesoCompetencias = filters => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_PESO_COMPETENCIA,
      payload: true,
    });
    const resp = await PesoCompetenciaServices.getPesoCompetencias(filters);
    // console.clear();
    // console.log('RESPONSE => ', resp.data);
    dispatch({
      type: actions.GET_PESO_COMPETENCIA,
      payload: resp.data, // agregar .data
      pesoCompetencias: resp.data.data,
    });
    dispatch({
      type: actions.PESO_COMPETENCIA_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.PESO_COMPETENCIA_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_PESO_COMPETENCIA,
      payload: false,
    });
  }
}

export const resetPesoCompetencias = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_PESO_COMPETENCIA,
      payload: true,
    });
    dispatch({
      type: actions.GET_PESO_COMPETENCIA,
      payload: {data:[],count:0}, // agregar .data
      pesoCompetencias: [],
    });
    dispatch({
      type: actions.PESO_COMPETENCIA_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.PESO_COMPETENCIA_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_PESO_COMPETENCIA,
      payload: false,
    });
  }
}

export const deletePesoCompetencia = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_PESO_COMPETENCIA,
      payload: true,
    });
    await PesoCompetenciaServices.deletePesoCompetencia(id);
    const { data, count } = getState().pesoCompetencia.pesoCompetencia;
    let _data = data.slice();
    _data.splice(index, 1);
    dispatch({
      type: actions.GET_PESO_COMPETENCIA,
      payload: {
        data: _data,
        count: count - 1
      },
    });
    dispatch({
      type: actions.PESO_COMPETENCIA_FALLA,
      payload: '',
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.PESO_COMPETENCIA_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_PESO_COMPETENCIA,
      payload: false,
    });
  }
}

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const editPesoCompetencia = (req, index, setError, setSaveLoader) => async (dispatch, getState) => {
  try {
    // dispatch({
    //   type: actions.LOADER_PESO_COMPETENCIA,
    //   payload: true,
    // });
    setSaveLoader(true)

  
    const resp = await PesoCompetenciaServices.editPesoCompetencia(req.id, req);
    const { data, count } = getState().pesoCompetencia.pesoCompetencia;
    let _data = data.slice();
    _data[index] = resp.data;
    dispatch({
      type: actions.GET_PESO_COMPETENCIA,
      payload: {
        data: _data,
        count: count,
      },
    });
    setError("")
    // dispatch({
    //   type: actions.FORM_PESO_COMPETENCIA_FAIL,
    //   payload: "",
    // });
    // setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data&&ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = ex.response.data[0];
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    // dispatch({
    //   type: actions.FORM_PESO_COMPETENCIA_FAIL,
    //   payload: message,
    // });
    setError(message)
  } finally {
    // dispatch({
    //   type: actions.LOADER_PESO_COMPETENCIA,
    //   payload: false,
    // });
    setSaveLoader(false)
  }
}

export const savePesoCompetencia = (req, setError, setSaveLoader) => async (dispatch, getState) => {
  try {
    // dispatch({
    //   type: actions.SAVE_LOADER_PESO_COMPETENCIA,
    //   payload: true,
    // });
    setSaveLoader(true)
    const resp = await PesoCompetenciaServices.savePesoCompetencia(req);
    const { data, count } = getState().pesoCompetencia.pesoCompetencia;
    dispatch({
      type: actions.GET_PESO_COMPETENCIA,
      payload: {
        count: count + 1,
        data: [...data, resp.data]
      },
    });
    // dispatch({
    //   type: actions.FORM_PESO_COMPETENCIA_FAIL,
    //   payload: "",
    // });
    setError("")
    // setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data&&ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = ex.response.data[0];
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    // dispatch({
    //   type: actions.FORM_PESO_COMPETENCIA_FAIL,
    //   payload: message,
    // });
    setError(message)
  } finally {
    // dispatch({
    //   type: actions.SAVE_LOADER_PESO_COMPETENCIA,
    //   payload: false,
    // });
    setSaveLoader(false)
  }
};
